import { EBackupImage } from '../enums/shared/EBackupImage';

export const getFallbackImageSource = (type: EBackupImage, isDark = false) => {
  switch (type) {
    case EBackupImage.WORD:
      return '/images/icons/backup/doc.png';
    case EBackupImage.EXCEL:
      return '/images/icons/backup/xls.png';

    case EBackupImage.PPT:
      return '/images/icons/backup/ppt.png';

    case EBackupImage.PDF:
      return '/images/icons/backup/pdf.png';

    default:
      return isDark
        ? '/images/icons/backup/imagePlaceholderDark.png'
        : '/images/icons/backup/imagePlaceholder.png';
  }
};
